import { computed } from 'vue';
import mitLogoUrl from '@/assets/mit-logo.svg';
import { useTheme } from '@/common/composables/useTheme';

// The MIT logo for the current theme. Dark mode uses the white logo when it
// has been added at src/assets/mit-logo-white.svg; until then it inverts the
// black one (`inverted`, applied as `filter: invert(1)` by the caller).
// Optional on purpose, so the file can land without a code change.
const whiteLogoUrl = Object.values(
  import.meta.glob<string>('@/assets/mit-logo-white.svg', {
    eager: true,
    query: '?url',
    import: 'default',
  })
)[0];

export function useMitLogo() {
  const { isDark } = useTheme();
  const url = computed(() => (isDark.value && whiteLogoUrl ? whiteLogoUrl : mitLogoUrl));
  const inverted = computed(() => isDark.value && !whiteLogoUrl);
  return { url, inverted };
}
